<template lang="pug">
.check-delete-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-header
    @ok="ok" @cancel="cancel")
    .check-delete-modal-body
      .confirm-title {{ title }}
      .confirm
        slot(name="message")
        label
          input(type="checkbox" @click="checked = !checked")
          span 確認しました

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### チェックボックス付き削除確認モーダル
 */
@Component
export default class CheckDeleteModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** タイトル */
  @Prop({ required: true })
  title!: string;

  /** 確認しました */
  checked: boolean = false;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * OKボタン押下イベント
   */
  public ok(): void {
    this.$emit("ok");
    this.checked = false;

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  public cancel(): void {
    this.$emit("cancel");
    this.checked = false;

    return;
  }
}
</script>
